// extracted by mini-css-extract-plugin
module.exports = {"root":"_bff6b2","categoryGroup":"_e482dc","ctaContainer":"_0618f3"};